import React, { memo } from 'react';
import useWallet from '../hooks/useWallet';
import { WalletIcon, ExclamationTriangleIcon, ArrowsRightLeftIcon } from '@heroicons/react/24/outline';

const WalletConnect = ({ className = '' }) => {
  const {
    isConnected,
    formattedAddress,
    isMetaMaskInstalled,
    network,
    isNetworkSupported,
    formattedBalance,
    switchToBSCTestnet,
    connectWallet,
  } = useWallet();

  if (!isMetaMaskInstalled) {
    return (
      <div
        className={`flex items-center px-6 py-3 bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400 font-semibold rounded-xl ${className}`}>
        <WalletIcon className='h-5 w-5 mr-2' />
        MetaMask Required
      </div>
    );
  }

  if (!isConnected) {
    return (
      <div className={`${className}`}>
        {/* Use AppKit web component for wallet connection */}
        {/* <appkit-button /> */}
        <button
          onClick={connectWallet}
          className='flex w-full justify-center items-center px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-semibold rounded-xl transition-all duration-200 transform hover:scale-105 shadow-lg'>
          <WalletIcon className='h-5 w-5 mr-2' />
          Connect Wallet
        </button>
      </div>
    );
  }

  return (
    <div className={`flex flex-col space-y-2 ${className}`}>
      {/* Network Warning */}
      {!isNetworkSupported && (
        <div className='flex items-center space-x-2 px-3 py-2 bg-yellow-50 dark:bg-yellow-900/50 border border-yellow-200 dark:border-yellow-700/50 rounded-lg'>
          <ExclamationTriangleIcon className='h-4 w-4 text-yellow-600 dark:text-yellow-400' />
          <p className='text-xs flex-1 text-yellow-700 dark:text-yellow-300'>Switch to a supported network to play</p>
          <button
            onClick={switchToBSCTestnet}
            className='flex items-center cursor-pointer text-sm bg-black/80 font-bold backdrop-blur-sm rounded-lg px-2 py-1 space-x-1 text-yellow-600 dark:text-yellow-400 hover:text-yellow-700 dark:hover:text-yellow-300'>
            <ArrowsRightLeftIcon className='h-3 w-3' />
            <span>Switch</span>
          </button>
        </div>
      )}

      {/* Connected Wallet Info */}
      <div
        onClick={connectWallet}
        className='flex cursor-pointer min-w-[300px] w-full items-center justify-between px-4 py-3 bg-white/70 dark:bg-gray-800/70 backdrop-blur-sm border border-white/20 dark:border-gray-700/50 rounded-xl shadow-lg'>
        <div className='flex items-center space-x-3'>
          <div className='w-10 h-10 bg-sky-200 rounded-full flex items-center justify-center'>
            <WalletIcon className='h-6 w-6 text-dark' />
          </div>
          <div className='text-left'>
            <p className='text-sm font-medium text-gray-900 dark:text-white'>{formattedAddress}</p>
            <div className='flex items-center space-x-2'>
              <div className={`w-2 h-2 rounded-full ${isNetworkSupported ? 'bg-green-500' : 'bg-yellow-500'}`} />
              <p className='text-xs text-gray-500 dark:text-gray-400'>{network?.name || 'Unknown Network'}</p>
            </div>
            <p className='text-xs text-gray-400 dark:text-gray-500'>{formattedBalance}</p>
          </div>
        </div>
        {/* Use AppKit web component for wallet management */}
        {/* <appkit-button /> */}
      </div>
    </div>
  );
};

export default memo(WalletConnect);
